module.exports = __webpack_public_path__ + "img/炸弹.038a8474.png";